import axios from 'axios'

export default {
  search: function (vacancyId) {
    return axios.get('/api/vacancy/getEmployerHistoryList?id=' + vacancyId)
  },
  find: function (id) {
    return axios.get('/api/vacancy/findEmployerHistory?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveEmployerHistory', data)
  },  
  delete: function (id) {
    return axios.delete('/api/vacancy/deleteEmployerHistory?id='+id)
  }
}